export enum LanguageEnum {
    nb = 1,
    en = 2,
    se = 3,
    da = 4,
}
